export default "__VITE_ASSET__DvHGm2TY__"